import { DialogHeader, DialogTitle } from "design-system/dialog";
import type { ReactNode } from "react";
import { SecuredByTurnkeyBadge } from "./secured-by-turnkey-badge";

// Header for the designed wallet-creation steps: title + optional step badge + Turnkey attribution, matching the
// Figma frames. The description is rendered by each screen in the body, not here, so it stays left-aligned
// (DialogHeader centers text). Callers pass the step badge as JSX (or omit it), so screens shared across flows
// (e.g. the email OTP) can drop it where a wallet-creation step counter is meaningless, like re-auth to sign.
export function StepHeader({ badge, secured = true, title }: { badge?: ReactNode; secured?: boolean; title: string }) {
  return (
    <DialogHeader>
      <div className="flex flex-wrap items-center gap-2">
        <DialogTitle>{title}</DialogTitle>
        {badge}
        {secured ? <SecuredByTurnkeyBadge /> : null}
      </div>
    </DialogHeader>
  );
}
